module.exports = __webpack_public_path__ + "static/img/login_logo3.522c5821.png";